module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.requestPending) ? _c('div') : (!_vm.showError) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.lang.AR0001))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lang.AR0002))])]) : _c('div', [_c('h2', [_vm._v(_vm._s(_vm.lang.AR0003))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lang.AR0004))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaf33c1a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppRegistration/AppRegistration.vue
// module id = 421
// module chunks = 1 2